import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ChevronUpIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M11.3 8.3a1 1 0 0 1 1.4 0l6 6a1 1 0 0 1-1.4 1.4L12 10.42l-5.3 5.3a1 1 0 0 1-1.4-1.42l6-6Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ChevronUpIcon;
